import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperModule } from './stepper/stepper.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CopyToClipboardDirective } from './directives/copy-to-clipboard.directive';
import { CopyButtonComponent } from './components/copy-button/copy-button.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { ContentEditableDirective } from './directives/content-editable.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  declarations: [
    ContentEditableDirective,
    CopyToClipboardDirective,
    CopyButtonComponent,
    LoadingSpinnerComponent,
    FileUploadComponent,
  ],
  imports: [CommonModule, MatIconModule, FormsModule, ReactiveFormsModule],
  providers: [],
  exports: [
    ContentEditableDirective,
    FormsModule,
    ReactiveFormsModule,
    CopyButtonComponent,
    LoadingSpinnerComponent,
    FileUploadComponent,
    StepperModule,
    MatIconModule,
  ],
})
export class SharedModule {}
